module.exports = __webpack_public_path__ + "img/artboard4.4ce9ea8a.png";